import { useContext, useEffect, useCallback } from "react";
import { EditCustomCardContext } from "../contexts/EditCustomCardContext";
import LineupCardApi from "../../../httpClients/LineupCardApi";
import { useAlert } from "../../alerts/AlertsContext";
import { trackPromise } from "react-promise-tracker";

export const useLogoUpload = (logoConfigs, cardType = "dugout") => {
  const editCustomCardContext = useContext(EditCustomCardContext);
  const showAlert = useAlert();
  const { dispatch } = editCustomCardContext;
  const cardInfo =
    cardType === "lineup" ? editCustomCardContext.state.lineupCardInfo : editCustomCardContext.state.dugoutCardInfo;

  useEffect(() => {
    logoConfigs.forEach(({ fileNameKey, dispatchType, logoType }) => {
      const fileName = cardInfo[fileNameKey];
      if (fileName) {
        trackPromise(
          LineupCardApi.getLogoByFileName(fileName)
            .then((response) => {
              const editedKey = cardType === "lineup" ? "lineupEdited" : "dugoutEdited";
              dispatch({
                type: dispatchType,
                [logoType]: {
                  name: fileName,
                  fileBase64String: response.fileBase64String,
                  subType: logoType,
                },
                [editedKey]: false,
              });
            })
            .catch(() => {
              showAlert(`Error retrieving image!`, `danger`);
            }),
        );
      }
    });
  }, [logoConfigs.map((c) => cardInfo[c.fileNameKey]).join(",")]);

  const addFile = useCallback(
    (dispatchType, logoType, file) => {
      if (file.length) {
        const reader = new FileReader();
        const editedKey = cardType === "lineup" ? "lineupEdited" : "dugoutEdited";
        reader.onload = () => {
          dispatch({
            type: dispatchType,
            [logoType]: {
              name: file[0].name,
              fileBase64String: reader.result,
              subType: logoType,
            },
            [editedKey]: true,
          });
        };
        reader.readAsDataURL(file[0]);
      }
    },
    [dispatch],
  );

  const removeFile = useCallback(
    (dispatchType, logoType) => {
      const editedKey = cardType === "lineup" ? "lineupEdited" : "dugoutEdited";
      dispatch({
        type: dispatchType,
        [logoType]: null,
        [editedKey]: true,
      });
    },
    [dispatch],
  );

  return { cardInfo, addFile, removeFile };
};
